import React, { memo } from 'react';
// import { Switch, Route, Redirect } from 'react-router-dom';

// import ProjectsForm from './projectsForm';
import { Routes } from '@components';

// import '@style/modules/project/project.scss';
import '../../styles/modules/project/project.scss';

function AnalysisRoute(props) {
  const { match, routes } = props;
  return <Routes routeData={routes} rootPath={match.path} />;
}

export default memo(AnalysisRoute);
